import TransparentCharacterImage from './TransparentCharacterImage';
import type {VisualEmployee} from './OrdinaryWorkforceHome';
import AgentCharacterAvatar from './AgentCharacterAvatar';
import {isPraamis} from '../lib/praamisIdentity';

/**
 * Every employee surface uses the same saved Character Studio identity.
 * Preview-only portrait choices are used solely when no saved character
 * profile exists; the official Praamis green orb is never replaceable.
 */
export type PreviewPortraitChoice='default'|'owl'|'bookworm'|'female';

export function getPreviewPortraitChoice(id:string):PreviewPortraitChoice {
 try{
  const value=localStorage.getItem('agentordinary-preview-portrait:'+id);
  if(value==='owl'||value==='bookworm'||value==='female')return value;
 }catch{}
 return 'default';
}

type Props={
 employee:VisualEmployee;
 size?:number;
 className?:string;
 previewChoice?:PreviewPortraitChoice;
};

export default function EmployeeIdentityPortrait({employee,size=56,className='',previewChoice}:Props){
 if(isPraamis({official_name:employee.name,role_key:employee.roleKey,nickname:employee.nickname})||employee.profile){
  return <AgentCharacterAvatar
   name={employee.name}
   roleKey={employee.roleKey}
   profile={employee.profile}
   status={employee.status}
   size={size}
   className={className}
  />;
 }
 const choice=previewChoice??getPreviewPortraitChoice(employee.id);
 if(choice==='default'){
  return <AgentCharacterAvatar
   name={employee.name}
   roleKey={employee.roleKey}
   status={employee.status}
   size={size}
   className={className}
  />;
 }
 const art=choice==='owl'
  ? '/character-assets/owl-approved-static.webp'
  : choice==='bookworm'
  ? '/character-assets/bookworm-approved-clear-hires.avif'
  : '/character-assets/default-agent-female.webp';
 return <span
  className={'agent-portrait '+className}
  style={{width:size,height:size,flex:'0 0 '+size+'px'}}
  role="img"
  aria-label={employee.name+' assigned character'}
 ><TransparentCharacterImage
   src={art}
   alt=""
   className="agent-portrait-img"
   loading="lazy"
   draggable={false}
   style={{width:'100%',height:'100%',objectFit:'contain'}}
 /></span>;
}
